function KnowMore() {
    return (
        <section className="s2">
        <div className="main-container">
            <div className="about-wrapper">
                <div className="about-me">
                    <h4>More about me</h4>
                    <p>
                        For quite a time I have been discovering this
                        awesome development space from Cloud Computing
                        to the Blockchain, the tech and the
                        opportunities for Improvement it creates for
                        society drive me to build awesome stuff and
                        create a positive impact.
                    </p>
                </div>
                <div className="social-links">
                    <h3>Find me on Github and Twitter</h3>
                    <a
                        target="_blank"
                        rel="noreferrer"
                        href="https://github.com/adityabhattad2021"
                    >
                        Github: adityabhattad2021
                    </a>
                    <a
                        target="_blank"
                        rel="noreferrer"
                        href="https://twitter.com/bhattad_aditya"
                    >
                        Twitter: @bhattad_aditya
                    </a>
                </div>
            </div>
        </div>
    </section>

    )
}

export default KnowMore;